import ScannerError from "models/scanner-error";
import { ScannerInstanceType, ScannerType } from "models/scanner-type";
import { MultiPaxSessionId } from "models/session/session";

import { IScanner } from "./scanner";

// Scanners that need app-load initialization (a heavy SDK their capturer
// depends on). Loaded via dynamic import() so non-REGULA builds keep the Regula
// SDK out of the main chunk. Scanners not listed here self-initialize inside
// their own capturer (Capture, BlinkID, Incode), so they need no app-load init.
const initRegistry: Partial<
  Record<ScannerType, () => Promise<{ default: IScanner }>>
> = {
  [ScannerType.REGULA]: () => import("./scanner-REGULA"),
};

export const initScannerForType = async (
  type: ScannerType | undefined,
  sessionId: MultiPaxSessionId,
  onError: (e: ScannerError) => void,
  onSuccess: (instanceType: ScannerInstanceType) => void
): Promise<void> => {
  if (!type) {
    return;
  }

  const loader = initRegistry[type];
  if (!loader) {
    return;
  }

  const { default: scanner } = await loader();
  scanner.init(sessionId, onError, onSuccess);
};
